import angular from 'angular';
import reactInAngular from 'react-in-angular1';
import ReduxDecorator from './React/HOC/reduxProvider.jsx';

angular.module('app.react', [])
    .component('reduxDecorator', reactInAngular(ReduxDecorator, ['reduxProvider', 'render', 'gettextCatalog', 'passThrough', 'location', 'injector']));
